import type { IconButtonProps, IconButtonTypeMap } from '@mui/material';
import type { ElementType } from 'react';

import { IconButton } from '@mui/material';
import React, { forwardRef } from 'react';
import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  circleButton: {
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
    'backgroundColor': theme.palette.common.white,
    'boxShadow': theme.shadows[3],
    'height': 44,
    'padding': 10,
    'width': 44,
  },
}));

export const CircleButton = forwardRef<
  HTMLButtonElement,
  IconButtonProps<ElementType, NonNullable<unknown>>
>(({ children, ...rest }, ref) => {
  const { classes } = useStyles();

  return (
    <IconButton {...rest} className={classes.circleButton} ref={ref}>
      {children}
    </IconButton>
  );
}) as <
  D extends ElementType = IconButtonTypeMap['defaultComponent'],
  P = NonNullable<unknown>,
>(
  props: IconButtonProps<D, P> & { ref?: React.Ref<HTMLButtonElement> },
) => React.ReactElement;
